import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styled from '@emotion/styled'
import setMinHeightByScreen from '../../component/script/set_minheight_by_screen';

const PageNotFoundWrapper = styled.main`
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    color: var(--color-black-200);
    background-color: var(--color-gray-blue-100);
    h1 {
        font-size: 30px;
        font-weight: 300;
        margin-bottom: 25px;
    }
    p {
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 50px;
    }
    a {
        align-items: center;
        padding: 14px 25px;
        justify-content: center;
        color: var(--color-blue-900);
        font-weight: 700;
        border-radius: 99999px;
        background-color: inherit;
        box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.75), 5px 5px 10px 0px rgba(0, 0, 0, 0.05);
        &:hover{
            box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.75) inset, 5px 5px 10px 0px rgba(0, 0, 0, 0.05) inset;
        }
    }
`

const PageNotFound = () => {
    const NotFoundRef = useRef(null)
    const [remainingTime, setRemainingTime] = useState(5);
    const navigate = useNavigate();

    useEffect(() => {
        const timeoutId = setInterval(() => {
        // 1초마다 remainingTime을 감소시킴
        setRemainingTime(prevTime => prevTime - 1);
        }, 1000);

        // 남은 시간이 0이 되면 페이지 이동
        if (remainingTime === 0) {
        navigate('/');
        }

        return () => clearInterval(timeoutId);
    }, [navigate, remainingTime]);

    useEffect(()=>{
        setMinHeightByScreen(NotFoundRef);
        document.title = "페이지를 찾을 수 없습니다 - 메이플스토리 전투력 측정기"
    },[])

  return (
    <PageNotFoundWrapper ref={NotFoundRef}>
        <h1>
            페이지를 찾을 수 없습니다.
        </h1>
        <p>{`${remainingTime}초 후 home으로 이동합니다.`}</p>   
        <Link to="/">
            Home으로 이동
        </Link>
    </PageNotFoundWrapper>
  );
};

export default PageNotFound;
